// BFSG
import * as React from 'react'
import styled from 'styled-components'
import HotspotItem from './HotspotItem'
import * as t from './types'
import Image from 'theme/molecules/Image'

export default function HotspotTeaser(props: t.Props) {
  const [active, setActive] = React.useState<number | null>(0)

  return (
    <Wrapper className="HotspotTeaser" data-cy-ctx="molecules/HotspotTeaser">
      <div className="hotspot-container">
        <div className="teaser-image">
          <Image img={props.context.optImg} alt="HotspotTeaser" />
        </div>
        <div className="hotspot-items">
          {props.context.items.map((item, index) => (
            <HotspotItem
              setActive={(forceActive) =>
                setActive((b) =>
                  forceActive ? index : b === index ? null : index
                )
              }
              active={active === index}
              key={index}
              {...item}
            />
          ))}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;

  > .hotspot-container {
    position: relative;
    > .teaser-image {
      width: 100%;
    }
  }
`
